import React from 'react';
import { X } from 'lucide-react';
import QuizModeSelector from './QuizModeSelector';
import { playSound } from '../../utils/soundManager';

const QuizModeModal = ({ 
  isOpen, 
  onClose, 
  currentMode, 
  onSelect,
  difficulty 
}) => {
  if (!isOpen) return null;

  const handleSelect = (mode) => {
    playSound('success');
    onSelect(mode);
    setTimeout(() => onClose(), 300);
  };

  const handleClose = () => {
    playSound('click');
    onClose();
  };

  return (
    <div className="quiz-mode-modal-overlay" onClick={handleClose}>
      <div 
        className="quiz-mode-modal-content animate-scaleIn" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="quiz-mode-modal-header">
          <h2>Quiz Mode</h2>
          <button 
            className="quiz-mode-modal-close hover-scale"
            onClick={handleClose}
          >
            <X size={24} />
          </button>
        </div>
        
        <div className="quiz-mode-modal-body">
          <QuizModeSelector
            currentMode={currentMode}
            onSelect={handleSelect}
            difficulty={difficulty}
            onClose={handleClose}
          />
        </div>
      </div>
    </div>
  );
};

export default QuizModeModal;
